// Invitation list: GET /dmut/get-invitation query builder, status metadata and
// the Excel/CSV export. Fetch and download helpers are shared with the Plan &
// Procurement list.

import { api } from '../../../config';
import { downloadSheet } from '../../Procurement/utils/procurementList';
import { getListProductTypeLabel } from '../../../shared/offer-domain/constants';

export const INVITATION_PROCUREMENT_TYPE_MAP = {
  '': '-',
  PelelanganKhusus: 'Pelelangan Khusus',
  PemilihanLangsung: 'Pemilihan Langsung',
  TunjukLangsung: 'Tunjuk Langsung',
};

// `value` is the Status query value and the statusInvitationWording a row
// carries. `tone` drives the to-status / to-stat / to-mcard modifier.
export const INVITATION_STATUSES = [
  { value: 'Open', icon: 'ri-mail-open-line', tone: 'info', stat: 'open' },
  {
    value: 'Closing',
    icon: 'ri-hourglass-line',
    tone: 'muted',
    stat: 'muted',
  },
  {
    value: 'Past Deadline',
    icon: 'ri-timer-flash-line',
    tone: 'warning',
    stat: 'progress',
  },
  {
    value: 'Accepted',
    icon: 'ri-checkbox-circle-line',
    tone: 'success',
    stat: 'done',
  },
  {
    value: 'Declined',
    icon: 'ri-close-circle-line',
    tone: 'danger',
    stat: 'danger',
  },
];

export const getInvitationStatus = wording =>
  INVITATION_STATUSES.find(status => status.value === wording);

export const DEFAULT_SORT_FIELD = 'procurementNumber';

export const buildInvitationListUrl = ({
  currentPage,
  rowsPerPage,
  procurementTypeHeader,
  search,
  status,
  sortField,
  sortDirection,
}) => {
  const params = new URLSearchParams();
  params.set('PageNumber', String(currentPage));
  params.set('PageSize', String(rowsPerPage));
  params.set('ProcurementTypeHeader', procurementTypeHeader || '');
  if (sortField) {
    params.set('SortBy', sortField);
    params.set('IsDescending', sortDirection === 'desc' ? 'true' : 'false');
  }
  if (search) params.set('Search', search);
  if (status) params.set('Status', status);
  return `${api.API_URL}/dmut/get-invitation?${params.toString()}`;
};

const toExportRow = row => ({
  'ID Proc': row.procurementNumber || '',
  Title: row.titleProcurement || '',
  'Proc Type':
    INVITATION_PROCUREMENT_TYPE_MAP[row.procurementType] ||
    row.procurementType ||
    '',
  Product: row.productType?.product?.name || '',
  'Product Type': getListProductTypeLabel(row, row.productType?.name) || '',
  Description: row.description || '',
  Status: row.statusInvitationWording || '',
});

export const exportInvitationList = (rows, { format, sheetName }) =>
  downloadSheet(rows.map(toExportRow), {
    format,
    prefix: 'Invitation',
    sheetName,
  });
